import { useEffect, useState } from 'react'
import './visual-novo.css'
// o resto do app (Início, Quadro, Item, login...) — SPEC-20260930-0522
import '../../styles/visual-novo-app.css'

/**
 * Visual novo do Orbind — definitivo desde SPEC-20261007-1409 (antes era a
 * chave de teste de liga/desliga, SPEC-20260929-0101 / SPEC-20260930-0522).
 *
 * O CSS continua preso a `:root[data-ch-visual='novo']`; o atributo agora é
 * fixo. Na engrenagem da Comunicação sobra só a escolha do estilo
 * (Oceano/Aurora/Grafite/WhatsApp ou Meus Estilos), guardada no navegador.
 */

// chave da época do teste (liga/desliga): não é mais usada
const CHAVE_ANTIGA = 'orbind.chat.visual-novo'
const CHAVE_TEMA = 'orbind.chat.visual-novo.tema'

/** Os 4 estilos do chat do site. `null` = segue o que estiver em Meus Estilos. */
export const TEMAS_DO_VISUAL_NOVO = [
  { id: 'oceano', rotulo: 'Oceano' },
  { id: 'aurora', rotulo: 'Aurora' },
  { id: 'grafite', rotulo: 'Grafite' },
  { id: 'whatsapp', rotulo: 'WhatsApp' },
] as const
export type TemaDoVisualNovo = (typeof TEMAS_DO_VISUAL_NOVO)[number]['id']

function ler(chave: string): string | null {
  try {
    return localStorage.getItem(chave)
  } catch {
    return null
  }
}
function gravar(chave: string, valor: string | null) {
  try {
    if (valor === null) localStorage.removeItem(chave)
    else localStorage.setItem(chave, valor)
  } catch {
    /* navegador sem armazenamento: vale só nesta aba */
  }
}

function aplicar(tema: TemaDoVisualNovo | null) {
  const raiz = document.documentElement
  raiz.dataset.chVisual = 'novo'
  if (tema) raiz.dataset.chTema = tema
  else delete raiz.dataset.chTema
}

const temaValido = (v: string | null): TemaDoVisualNovo | null =>
  TEMAS_DO_VISUAL_NOVO.some((t) => t.id === v) ? (v as TemaDoVisualNovo) : null

// aplica já no carregamento do módulo: nada de "piscar" o visual antigo
aplicar(temaValido(ler(CHAVE_TEMA)))
gravar(CHAVE_ANTIGA, null)

type Estado = { tema: TemaDoVisualNovo | null }
const ouvintes = new Set<(e: Estado) => void>()
let atual: Estado = { tema: temaValido(ler(CHAVE_TEMA)) }

function mudar(parcial: Partial<Estado>) {
  atual = { ...atual, ...parcial }
  gravar(CHAVE_TEMA, atual.tema)
  aplicar(atual.tema)
  for (const o of ouvintes) o(atual)
}

export function useVisualNovo() {
  const [estado, setEstado] = useState(atual)
  useEffect(() => {
    ouvintes.add(setEstado)
    return () => {
      ouvintes.delete(setEstado)
    }
  }, [])
  return {
    tema: estado.tema,
    setTema: (tema: TemaDoVisualNovo | null) => mudar({ tema }),
  }
}
